/**
 * Ad-hoc one-time fees (#2) — a manual fee charged directly to an Agreement (no account,
 * no schedule). Admin create/cancel; read for the agreement's Fees tab. VAT + total are
 * derived server-side. Surfaces in View History totals + the accountant export.
 */
import { api } from './client';
import type { ISODate, ISODateTime, UUID } from './types';

export interface AdhocFee {
  id: UUID;
  agreement_id: UUID;
  period_month: ISODate;
  description: string;
  net_fee_cents: number;
  vat_rate_bps: number;
  vat_cents: number;
  total_fee_cents: number;
  created_at: ISODateTime | null;
}

export interface AdhocFeeCreateInput {
  agreement_id: UUID;
  period_month: ISODate;   // any day; server normalises to first-of-month
  description: string;
  net_fee_cents: number;   // ex-VAT (may be negative — a one-off credit)
  vat_rate_bps: number;
}

export const adhocFeesApi = {
  listForAgreement: (agreementId: UUID) =>
    api.get<AdhocFee[]>(`/adhoc-fees?agreement_id=${agreementId}`),
  listForMonth: (period: string) =>
    api.get<AdhocFee[]>(`/adhoc-fees?period=${encodeURIComponent(period)}`),
  create: (body: AdhocFeeCreateInput) => api.post<AdhocFee>('/adhoc-fees', body),
  cancel: (id: UUID) => api.delete<void>(`/adhoc-fees/${id}`),
};
